/**
 * Credits API endpoint constants.
 */
export const CREDITS_ENDPOINTS = {
    GET_BALANCE: '/credits/balance',
    GET_MODEL_USAGE: '/credits/model-usage',
    DEDUCT: '/credits/deduct',
};
//# sourceMappingURL=endpoints.js.map